<template>
	<div class="upload-image-container">
		<el-upload
			ref="myUpload"
		 :action="uploadUrl" :on-change="handleChange" :before-upload="beforeUpload"
			:on-success="handleSuccess" :on-error="handleError" :file-list="fileList" :auto-upload="false"
			:show-file-list="false" :limit="limit" :on-exceed="handleExceed" :accept="accept" :on-remove="handleRemove">
			<template>
				<div v-if="limit===1" style="display: flex;">
					<div v-if="value" class="avatar" @click.stop="" style="margin-right: 10px">
						<!-- <ImageViewer :preview="false" :src="value" /> -->
						<ImageViewer :key="value"  :src="value" />
						<!-- <img style="width: 100%;height: 100%;" :src="imageDomain+value" alt="" /> -->
					</div>
					<div  class="avatar" style="border: 1px dashed #ccc;border-radius: 4px;">
						<i class="el-icon-plus avatar-uploader-icon"></i>
					</div>
				</div>
				<div v-else style="display: flex;"  @click.stop="" >
					<div v-for="(item,index) in value?value.split(','):[]"class="avatar" style="margin-right: 10px;;position: relative;">
						<ImageViewer :key="item"  :src="item" />
						
						<el-button icon="el-icon-delete" type="danger" plain class="delImg" @click="deleteImg(index)" circle size="mini"></el-button>
						
						<!-- <img style="width: 100%;height: 100%;" :src="imageDomain+item" alt="" /> -->
					</div>
					<div  class="avatar" @click="goUpload" v-if="value.split(',').length<limit" style="border: 1px dashed #ccc;border-radius: 4px;">
						<i class="el-icon-plus avatar-uploader-icon"></i>
					</div>
				</div>
			</template>
		</el-upload>
	</div>
</template>

<script>
	import api from '../utils/api'

	export default {
		name: 'UploadImage',
		props: {
			value: {
				type: [String, Array],
				default: () => ''
			},
			limit: {
				type: Number,
				default: 1
			},
			tip: {
				type: String,
				default: '支持上传 JPG、PNG、GIF 格式的图片，单个文件不超过 5MB'
			},
			accept: {
				type: String,
				default: 'image/jpeg,image/png,image/gif'
			}
		},
		data() {
			return {
				fileList: [],
				uploadUrl: '' // 由于我们使用手动上传，这里不需要设置action
			}
		},
		computed: {
			imageDomain() {
				return this.$store.getters.getImg
			}
		},
		watch: {
		/* 	
			value: {
			   handler(newVal, oldVal) {
			     if (newVal && JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
			       // 处理字符串类型的value
			       const urls = typeof newVal === 'string' ? [newVal] : newVal
			       this.fileList = urls.map(url => ({
			         url: url.startsWith('http') ? url : `${this.imageDomain}/${url}`,
			         name: url.split('/').pop(),
			         status: 'success'
			       }))
			     }
			   },
			   immediate: true
			 } */
		},
		methods: {
			deleteImg(index){
				const list = this.value.split(',')
				list.splice(index,1)
				console.log(list)
				this.$emit('input', list.join(','))
				// 保持原有的change事件，确保向后兼容
				this.$emit('change', list.join(','))
			},
			goUpload(){
				  const uploadEl = this.$refs.myUpload && this.$refs.myUpload.$el
				  const input = uploadEl && uploadEl.querySelector('input[type="file"]')
				  if (input) {
					  input.click()
				  }
			},
			handleChange(file, fileList) {
				// 当文件选择后，自动上传
				if (file.status === 'ready') {
					this.uploadFile(file)
				}
			},
			beforeUpload(file) {
				const isImage = /^image\/(jpeg|png|gif)$/.test(file.type)
				const isLt5M = file.size / 1024 / 1024 < 5
				if(this.limit>1&&this.value.split(',').length>=this.limit){
					console.log('24444444444444')
					return false
				}

				if (!isImage) {
					this.$message.error('只能上传图片文件！')
					return false
				}
				if (!isLt5M) {
					this.$message.error('图片大小不能超过 5MB！')
					return false
				}

				return false // 返回false，阻止自动上传，使用手动上传
			},
			uploadFile(file) {
				this.$loading({
					lock: true,
					text: '上传中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				})

				api.file.uploadImage(file.raw)
					.then(res => {
						this.$loading().close()
						let relativePath = res.data.fileInfo.relativePath
						const list =this.value?this.value.split(','):[]
						list.push(relativePath)
						const output = this.limit === 1 ? relativePath : list.join(',')

						// 触发input事件，支持v-model
						this.$emit('input', output)
						// 保持原有的change事件，确保向后兼容
						this.$emit('change', output)
						this.$message.success('图片上传成功')
					})
					.catch((err) => {
						console.log(err)
						this.$loading().close()
						this.$message.error('图片上传失败')
						// 更新文件列表，标记上传失败的文件
						const index = this.fileList.findIndex(item => item.uid === file.uid)
						if (index !== -1) {
							this.fileList[index].status = 'fail'
						}
					})
			},
			handleSuccess(response, file, fileList) {
				this.fileList = fileList
				// 处理输出类型，根据输入类型返回相应的格式
				const urls = fileList.map(item => (item.response && item.response.data && item.response.data.url) || item.url)
				const output = typeof this.value === 'string' && this.limit === 1 ? urls[0] || '' : urls
				// 触发input事件，支持v-model
				this.$emit('input', output)
				// 保持原有的change事件，确保向后兼容
				this.$emit('change', output)
			},
			handleError(err, file, fileList) {
				this.$message.error('上传失败')
			},
			handleExceed(files, fileList) {
				this.$message.warning(`最多只能上传 ${this.limit} 张图片`)
			},
			handleRemove(file, fileList) {
				this.fileList = fileList
				// 处理输出类型，根据输入类型返回相应的格式
				const urls = fileList.map(item => item.url.replace(this.imageDomain + '/', ''))
				const output = this.limit === 1 ? urls[0] || '' : urls
				console.log(fileList)
				// 触发input事件，支持v-model
				this.$emit('input', output)
				// 保持原有的change事件，确保向后兼容
				this.$emit('change', output)
			}
		}
	}
</script>
<style>
	.upload-image-container .el-upload {
		display: block;
	}
</style>
<style scoped>
	.upload-image-container {
		width: 100%;

	}
	.avatar{
		width: 100px;
		height: 100px;
		line-height: 100px;
	}
	.delImg{
		position: absolute;
		top: -10px;
		right: -5px;
		display: none;
	}
	.avatar:hover .delImg{
			display: block;
	}


	.preview-container {
		display: flex;
		flex-wrap: wrap;
		gap: 10px;
		margin-top: 10px;
	}

	.preview-item {
		position: relative;
		width: 100px;
		height: 100px;
		border: 1px solid #ebeef5;
		border-radius: 4px;
		overflow: hidden;
	}

	.preview-image {
		width: 100%;
		height: 100%;
	}

	.preview-actions {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, 0.5);
		color: #fff;
		text-align: center;
		padding: 4px;
		opacity: 0;
		transition: opacity 0.3s;
	}

	.preview-item:hover .preview-actions {
		opacity: 1;
	}

	.el-upload__tip {
		font-size: 12px;
		color: #909399;
		margin-top: 5px;
	}
</style>
